import { useState, useEffect } from "react";

const useOtherClientSignupRequest = (url) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [signupRequest, setSignupRequest] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const controller = new AbortController();

    const fetchData = async () => {
      try {
        const resp = await fetch(url, { signal: controller.signal });
        const data = await resp.json();

        if (!!data.signupRequestValid) {
          setSignupRequest(data.signupRequest);
        } else if (data.signupRequestError === "expired") {
          setError("Your signup link has expired.");
        } else if (data.signupRequestError === "submitted") {
          setError("It looks like you’ve already signed up.");
          setSubmitted(true);
        } else {
          setError("Failed to load signup details.");
        }
      } catch (err) {
        if (err.name === "AbortError") return;
        console.error("Failed to load signup details", err);
        setError("Failed to load signup details.");
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchData();

    return () => controller.abort();
  }, [url]);

  return { loading, error, signupRequest, submitted };
};

export default useOtherClientSignupRequest;
